/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MediaInfo from 'shared/ui/components/media/MediaInfo.vue';
import VideoPlayer from 'frontend-video-player/vue';

import { filter, get, isEmpty } from 'lodash';
import VideoProcessingStatus from 'shared/ui/components/media/VideoProcessingStatus.vue';

const __vue_script__ = {
    name: 'MediaPlayer',
    components: {
        MediaInfo,
        VideoPlayer,
        VideoProcessingStatus,
    },
    props: {
        details: {
            type: Object,
            default: () => {}
        },
        isContentHub: {
            type: Boolean,
            default: true
        },
        useCredentials: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            hasQuestionOnScreen: false,
            hasPollOnScreen: false
        };
    },

    computed: {
        /** @returns {string} */
        displayTimestamp() {
            return this.$utils.time.tsToFormat(this.details.timestamp);
        },

        captionsLabels() {
            return get(this, 'details.caption_labels', {});
        },

        visibleLabels() {
            return filter(Object.keys(this.captionsLabels));
        },

        languageControl() {
            return {
                id: 'language',
                config: isEmpty(this.captionsLabels) ? {} : {
                    subtitleTrackNames: this.captionsLabels,
                    visibleSubtitleTrackLabels: this.visibleLabels
                }
            };
        },

        subtitlesWidget() {
            return {
                id: 'subtitles',
                config: {
                    position: this.captionTextPosition
                }
            };
        },

        captionTextPosition() {
            const hasSomethingOnScreen = this.hasQuestionOnScreen || this.hasPollOnScreen;
            return hasSomethingOnScreen ? 'top' : 'bottom';
        },

        showProcessingStatus() {
            if (this.details.upload_error) {
                return true;
            }

            if (this.details.normalization_enforced) {
                return !this.details.video_processing_successful;
            }

            return !this.details.url;
        },

        playerConfig() {
            return {
                components: [
                    'seek-bar',
                    'play-pause-toggle',
                    'volume',
                    'time',
                    this.subtitlesWidget,
                    this.languageControl,
                    'fullscreen',
                    {
                        id: 'claps',
                        config: {
                            readonly: true,
                            useMetadata: true
                        }
                    },
                    {
                        id: 'polls',
                        config: {
                            useMetadata: true,
                            showResultsOnly: true,
                            labels: {
                                waitingPollResults: this.$i18n.t('poll.waitingPollResults')
                            }
                        }
                    },
                    {
                        id: 'qna',
                        config: {
                            useMetadata: true,
                            labels: {
                                answerNow: this.$i18n.t('qna.answerNow'),
                                anonymous: this.$i18n.t('qna.anonymous')
                            }
                        }
                    }
                ]
            };
        }
    },

    methods: {
        onError(error) {
            console.log('[video-player]', error.message);
        },

        onCustomAction(payload, context) {
            switch (context) {
                case 'qna':
                    return this.onQnaAction(payload);
                case 'polls':
                    return this.onPollAction(payload);
            }
        },

        onQnaAction(question) {
            this.hasQuestionOnScreen = !isEmpty(question);
        },

        onPollAction(poll) {
            this.hasPollOnScreen = !isEmpty(poll);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "media-player" },
    [
      _vm.showProcessingStatus
        ? _c(
            "div",
            { staticClass: "video-processing" },
            [_c("video-processing-status", { attrs: { video: _vm.details } })],
            1
          )
        : _c("video-player", {
            attrs: {
              "source-url": _vm.details.url,
              config: _vm.playerConfig,
              "use-credentials": _vm.useCredentials,
              autoplay: false,
              preload: true,
            },
            on: {
              "player-error": _vm.onError,
              "custom-action": _vm.onCustomAction,
            },
          }),
      _c("media-info", {
        attrs: { details: _vm.details, "is-content-hub": _vm.isContentHub },
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/media/MediaPlayer.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__